import { Facebook, Instagram } from 'lucide-react';

interface SocialLinksProps {
  variant?: 'default' | 'cta' | 'inline';
  showText?: boolean;
  className?: string;
}

const socials = [
  { 
    icon: Facebook, 
    href: 'https://www.facebook.com/profile.php?id=61582698747996', 
    label: 'Facebook',
    color: 'hover:text-[#1877F2]'
  },
  { 
    icon: Instagram, 
    href: 'https://www.instagram.com/zofia.digitalagency', 
    label: 'Instagram',
    color: 'hover:text-[#E4405F]'
  },
];

const SocialLinks = ({ variant = 'default', showText = false, className = '' }: SocialLinksProps) => {
  if (variant === 'cta') {
    return (
      <div className={`flex flex-col sm:flex-row items-center gap-4 ${className}`}>
        <span className="text-sm text-muted-foreground">Seguici sui social:</span>
        <div className="flex gap-3">
          {socials.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border bg-background/50 text-muted-foreground ${social.color} hover:border-gold transition-all group`}
            >
              <social.icon className="w-4 h-4 group-hover:scale-110 transition-transform" />
              {showText && <span className="text-sm">{social.label}</span>}
            </a>
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className={`inline-flex items-center gap-2 ${className}`}>
        {socials.map((social) => (
          <a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
            className={`text-muted-foreground ${social.color} transition-colors`}
          >
            <social.icon className="w-5 h-5" />
          </a>
        ))}
      </div>
    );
  }

  // Default variant - icon buttons
  return (
    <div className={`flex gap-3 ${className}`}>
      {socials.map((social) => (
        <a
          key={social.label}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.label}
          className={`w-10 h-10 rounded-full border border-border flex items-center justify-center text-muted-foreground ${social.color} hover:border-gold transition-all`}
        >
          <social.icon className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
